<template>
  <b-container>
    <b-row class="justify-content-center">
      <b-col md="10" lg="8">
        <h1>Edit Calendar</h1>

        <b-card>
          <calendar-form ref="calendar" />
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import CalendarForm from '@/components/users/CalendarForm'

export default {
  name: 'ProfileRegisterCalendar',
  components: {
    CalendarForm
  }
}
</script>
